   
    <!-- Validation Script -->
    function checkMandatory() {
    const fields = [
    { id: "Last_Name", name: "Name" },
    { id: "Mobile", name: "Contact Number" },
    { id: "Email", name: "Email ID" },
    { id: "City", name: "City" },
    { id: "State", name: "State" },
    { id: "Zip_Code", name: "Zip Code" },
    { id: "Country", name: "Country" }
    ];
    
    for (let field of fields) {
    const element = document.getElementById(field.id);
    if (element.value.trim() === "") {
    alert(`${field.name} cannot be empty.`);
    element.focus();
    return false;
    }
    }
    
    return true;
    }